import styled from "styled-components";
import { TABLET_M_BP } from "@website-builder/utilities/constants/style-constants/screen-sizes.js";

const isB2u = process.env.GATSBY_BUSINESS_VERTICAL === "b2u";

export const SecondaryNavWrapper = styled.nav`
	padding: 54px 96px 0 96px;
	transition: padding 0.3s ease;
	overflow-x: auto;

	${isB2u &&
	`
    @media only screen and (max-width: ${TABLET_M_BP}px) {
      display: none;
    }
  `}

	div:has(>&), section:has(>*>&) {
		position: sticky;
		position: -webkit-sticky;
		z-index: 10;
		top: -2px;
		${(p) => (p.isB2u ? "background-color: var(--theme-primary);" : null)}
	}

	${(p) =>
		p.isB2u
			? `
	  div:has(>&) {
      padding: 0;
    }
    `
			: null}

	&.stuck {
		padding: ${isB2u ? "0 96px" : "16px 96px 0"};
		${(p) => (p.isB2u ? null : "box-shadow: 0px 8px 12px rgba(0, 0, 0, 0.14);")}
	}
	.navigation-label {
		white-space: nowrap;
	}
	.stickyWrapper {
		background: var(--theme-primary, --primary-neutral-white);
		border-bottom: 1px solid var(--primary-green-600);
		display: flex;
		justify-content: space-between;
		align-items: ${isB2u ? "center" : "flex-end"};

		.linksWrapper {
			display: flex;
			align-items: center;
			flex-wrap: nowrap;
			column-gap: 1.5rem;
			a {
				p {
					color: var(
						--theme-light-font-color,
						var(--primary-neutral-nightshade-600)
					);
				}
				text-decoration: none;
				text-align: center;
				cursor: pointer;
				padding: 12px 0;
			}
			a:hover {
				p {
					font-weight: 600;
				}
				${isB2u ? "padding: 20px 0;" : "padding-bottom: 7px;"}
				border-bottom: 5px solid var(--theme-secondary, var(--primary-green-600));
			}
			a > p::before {
				display: block;
				content: attr(data-label);
				font-weight: bold;
				height: 0;
				overflow: hidden;
				visibility: hidden;
				padding: 0;
				margin: 0;
			}
		}

		.ctaWrapper {
			margin: ${(props) =>
				props.isMobile ? "12px 0px 12px 0px;" : "12px 0 12px 20px;"};
			display: flex;
			align-items: flex-end;
			justify-content: flex-end;
			button {
				font-weight: 400;
				margin-left: ${(props) => (props.isMobile ? "8px;" : "12px;")};
				white-space: nowrap;
			}
		}
	}

	&.stuck .stickyWrapper {
		border: none;
	}

	@media only screen and (max-width: ${TABLET_M_BP}px) {
		padding: 18px 24px 0 24px;
		&.stuck {
			padding: 0 18px;
		}
		.secondary-navigation-container {
			min-width: min-content;
		}
		.ctaWrapper button {
			width: min-content;
		}
		.stickyWrapper {
			align-items: center;
			justify-content: space-between;
		}
	}
`;

export const ModalContent = styled.div`
	& > * {
		color: var(--primary-neutral-nightshade-800);
	}

	.callUs {
		text-align: center;
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 2rem;
		max-width: 400px;
	}

	.email {
		max-width: 450px;
		h5 {
			margin-bottom: 2rem;
		}
	}

	a {
		color: var(--primary-neutral-nightshade-800);
	}
`;

export const ImageWrapper = styled.div`
	display: block;
	height: 80px;
	width: 80px;

	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		border-radius: 50%;
	}
`;
